const AuthReducer = (users = {}, action) => {
  switch (action.type) {
    case 'LOGGED_IN':
      return (users = action.payload);

    case 'LOGGED_OUT':
      return (users = action.payload);
    default:
      return users;
  }
};

export default AuthReducer;
